<template>
  <div class="container-entities">
    <p>
      Administra los portafolios de tu Contact Center. Si eres un BPO y tienes diferentes clientes,
      gestiona todos aquí.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>
    <div class="entradaBoton">
      <a-form>
        <a-form-item>
          <a-input
            v-model:value="search"
            placeholder="Buscar por empresa"
            class="form__input"
            @input="handleSearchEntities"
          >
            <template #prefix>
              <SearchOutlined />
            </template>
          </a-input>
        </a-form-item>
      </a-form>
      <ModalNewEntities @update="handleSearch" />
    </div>
    
    <TableEntities :loading="loading" @update="handleSearch"  />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { SearchOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import _ from "lodash";

import ModalNewEntities from "@/app/entities/components/modals/entities/ModalNewEntities.vue";
import TableEntities from "@/app/entities/components/tables/TableEntities.vue";

const store = useStore();

const search = ref("");
const loading = ref(false);
const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/operaciones/empresas-1/`;

const handleSearch = async () => {
  loading.value = true;
  try {
    await store.dispatch("fetchAllEntities", {
      filters: { search: search.value },
    });
  } catch (error) {
    message.error("No se pudo actualizar la tabla");
  } finally {
    loading.value = false;
  }
};

watch(
  search,
  _.debounce(() => handleSearch(), 500)
);
</script>

<style lang="sass" scoped>
.ant-form-item
  margin-bottom: 8px

.container-entities
  padding: 8px 20px

.entradaBoton
  display: flex
  justify-content: space-between
  margin-top: 12px
  margin-bottom: 6px

.form__input
  width: 380px
</style>
